import type { MantineThemeOverride } from '@mantine/core'

export const theme: MantineThemeOverride = {
	colors: {
		brand: ['#ecf5fe', '#d8e7f7', '#aacef0', '#7cb4eb', '#579ee7', '#4390e5', '#388ae5', '#2c76cc', '#2269b7', '#0c5ba1'],
	},
	fontFamily: 'Maven Pro',
	headings: { fontFamily: 'Monda' },
	primaryColor: 'brand',
	components: {
		Container: {
			defaultProps: {
				sizes: {
					xs: 540,
					sm: 768,
					md: 992,
					lg: 1200,
					xl: 1600,
					xxl: 2200,
					huge: 3000,
				},
			},
		},
	},
}
